import { Button } from "PFComponents/button";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useDownloadTextFile } from "PFCore/helpers/use_download_text_file";
import React from "react";
import { useTranslation } from "react-i18next";

import { ImportModalPage } from "../../constants/import_modal_page";
import { skillsCsvTemplate } from "../../constants/skills_csv_template";
import { useImportSkillsModalContext } from "../../contexts/import_skills_modal_context";
import commonCss from "../../import_skills_modal.module.scss";
import css from "./import_error_page.module.scss";

export const ImportErrorPage = (): JSX.Element => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "header.modals.import.upload" });
  const { setCurrentPage } = useImportSkillsModalContext();
  const download = useDownloadTextFile();

  return (
    <div className={commonCss.uploadFlowContainer}>
      <Icon name="warning" color="paletteRed1" className={css.warningIcon} />
      <Typography variant="h2" className={css.title} noMargin>
        {t("CSVImportFailed")}
      </Typography>
      <Typography variant="bodyRegular" className={css.bigMargin} noMargin>
        {t("weHadProblemsReadingTheFile")}
      </Typography>
      <Typography variant="bodyRegular" className={css.defaultMargin} noMargin>
        {t("needHelpWithFormatting")}
      </Typography>
      <Button
        text={t("downloadCSVTemplate")}
        kind="text"
        className={css.bigMargin}
        onClick={() => {
          download("template.csv", skillsCsvTemplate);
        }}
      />
      <Button text={t("retry")} kind="secondary" onClick={() => setCurrentPage(ImportModalPage.Upload)} />
    </div>
  );
};
